import { Box, Divider, useTheme } from "@mui/material";
import { RectangularLoader } from "../../molecules/skeleton-loader/RectangularLoader";
import { SingleContainerLayout } from "../../organisms/impact-assessment/SingleContainerLayout";
import { CardTableLoader } from "../../organisms/skeleton-loaders/CardTableLoader";
import { WorkflowChartBox } from "../../organisms/skeleton-loaders/WorkflowChartLoader";

export const UseCaseDetailLoader = () => {
  const theme = useTheme();

  return (
    <SingleContainerLayout
      minHeight="100%"
      sideBarSize="lg"
      hideTopRadiusAndPadding
      hideBorder
      topComponent={
        <Box display="flex">
          <Box
            width="100%"
            bgcolor={theme.palette.custom.primaryBackground}
            padding="10px"
            sx={{
              borderTopRightRadius: "6px",
              borderTopLeftRadius: "6px",
              borderBottom: 0,
            }}
            alignItems="center"
            display="flex"
            flexDirection="row"
            gap="10px"
          >
            <RectangularLoader height="45px" width="350px" />
            <Box
              display="flex"
              flexDirection="column"
              gap="10px"
              width="50%"
              height="100%"
              justifyContent="flex-start"
            >
              <Box display="flex" gap="10px" alignItems="center" width="100%">
                {[...Array(5)].map((_, index) => (
                  <RectangularLoader height="45px" width="100px" />
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      }
      leftComponent={
        <Box display="flex" flexDirection="column" gap="15px" padding="10px">
          <Box display="flex" flexDirection="column" gap="10px">
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
          </Box>
          <Divider />
          <RectangularLoader width="100%" height="150px" />
        </Box>
      }
      rightComponent={
        <Box display="flex" width="100%" flexDirection="column" gap="15px">
          <RectangularLoader width="100%" height="44px" />
          <Box display="flex" width="100%" flexDirection="column" gap="15px" paddingX="10px">
            <WorkflowChartBox />
            <Box display="flex" flexWrap="wrap" width="100%" height="100%" gap="10px">
              <CardTableLoader />
            </Box>
          </Box>
        </Box>
      }
    />
  );
};
